<div class="heading  px-4">
  <span>Information</span>
</div>
<div class="page">
  <div [formGroup]="annotationForm" class="main-containor px-4">
    <div class="first-row">
      <div
        [ngClass]="
          annotationForm.value.color?.length > 0 ? 'valid-field-border' : ''
        "
      >
        <mat-form-field appearance="outline">
          <mat-label>{{ "Color" }}</mat-label>
          <input
            readonly
            autocomplete="off"
            matInput
            required
            formControlName="color"
            [cpOutputFormat]="'hex'"
            [cpAlphaChannel]="'disabled'"
            [(colorPicker)]="color"
            [cpDisableInput]="true"
            cpDialogDisplay="popup"
            (colorPickerChange)="onChangeColor($event)"
          />
          <mat-error>{{ "Required field" }}</mat-error>
        </mat-form-field>
      </div>
      <div
        [ngClass]="
          annotationForm.value.textColor?.length > 0 ? 'valid-field-border' : ''
        "
      >
        <mat-form-field appearance="outline">
          <mat-label>{{ "Text Color" }}</mat-label>
          <input
            readonly
            autocomplete="off"
            matInput
            required
            formControlName="textColor"
            [cpOutputFormat]="'hex'"
            [cpAlphaChannel]="'disabled'"
            [(colorPicker)]="textColor"
            [cpDisableInput]="true"
            cpDialogDisplay="popup"
            (colorPickerChange)="onChangeBackgroundColor($event)"
          />
          <mat-error>{{ "Required field" }}</mat-error>
        </mat-form-field>
      </div>
      <div
        [ngClass]="
          annotationForm.value.opacity?.length > 0 ? 'valid-field-border' : ''
        "
      >
        <mat-form-field appearance="outline">
          <mat-label>{{ "Transparency" }}</mat-label>
          <input
            max="0.9"
            min="0.1"
            matInput
            type="number"
            step="0.1"
            maxlength="4"
            formControlName="opacity"
          />
          <mat-error>{{ "must be in range 0.1 - 0.9" }}</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="second-row">
      <div
        [ngClass]="
          annotationForm.value.eventType?.length > 0 ? 'valid-field-border' : ''
        "
      >
        <mat-form-field appearance="outline">
          <mat-label>{{ "Annotation Type" }}</mat-label>
          <input
            [readonly]="annotationData?.isDefault"
            matInput
            maxlength="50"
            formControlName="eventType"
          />
          <mat-error>{{ "Required field" }}</mat-error>
        </mat-form-field>
      </div>
      <div
        [ngClass]="
          annotationForm.value.label?.length > 0 ? 'valid-field-border' : ''
        "
      >
        <mat-form-field appearance="outline">
          <mat-label>{{ "Label" }}</mat-label>
          <input
            [readonly]="annotationData?.isDefault"
            maxlength="50"
            matInput
            formControlName="label"
          />
          <mat-error>{{ "Required field" }}</mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="example-annotation">
    <span class="example-seperator"></span>
    <div class="example-background">
      <span class="example-pulse">
        <svg width="600" height="200">
          <!-- Define the digital pulse using polyline -->
          <polyline
            points="10,100 30,100 30,50 40,50 40,100 70,100 70,50 90,50 90,100 120,100 120,50 130,50 130,100 160,100 160,50 180,50 180,100 210,100 210,50 230,50 230,100 260,100 260,50 280,50 280,100 310,100 310,50 330,50 330,100 360,100 460,100 330,100"
            style="stroke: red; stroke-width: 2; fill: none"
          />
        </svg>
      </span>
      <span
        class="example-back-box"
        [style.backgroundColor]="annotationForm.value.color"
        [style.opacity]="annotationForm.value.opacity"
      ></span>

      <label
        class="exmaple-text"
        [style.color]="annotationForm.value.textColor"
      >
        This is example text on annotation
      </label>
    </div>
  </div>
</div>
